@switch (showInputs()) {
    @case ('VARIANCE_ANALYSIS_INPUTS') {
        <div class="flexbox-column gap-16">
            <p class="fs-3">
                Certainly! To proceed with the variance analysis, I will need at least one of the following two inputs:
            </p>
            <div class="flexbox-row bot-response-body align-items-end pb-1">
                <mat-form-field class="fixed-label bot-form-field" floatLabel="always">
                    <mat-label>Provide the Value of Change(%)</mat-label>
                    <input
                            matInput
                            placeholder="Change(%)"
                            (keydown)="transformCAASRow($event)"
                            (blur)="updateVr($event, 'PERCENT')"
                            [formControl]="vrPercent"
                            maxlength="25"
                            autocomplete="off"
                    />
                </mat-form-field>
                <mat-form-field class="fixed-label bot-form-field" floatLabel="always">
                    <mat-label>Provide the input of Change($)</mat-label>
                    <input
                            matInput
                            placeholder="Change($)"
                            (keydown)="transformCAASRow($event)"
                            (blur)="updateVr($event, 'VALUE')"
                            [formControl]="vrValue"
                            maxlength="25"
                            autocomplete="off"
                    />
                </mat-form-field>
                @if (!isReadOnly()) {
                    <div class="flexbox-row justify-content-end mt-3">
                        <button mat-button mat-flat-button color="primary" class="button-default"
                                [disabled]="!hasValidVr() || isReadOnly()"
                                (click)="submitVr()">Submit
                        </button>
                    </div>
                }
            </div>
        </div>

    }
    @case ('FILE') {
        <div class="flexbox-column gap-16">
            @if (inputType() === 'IS' || inputType() === 'RECONCILIATION') {
                <span class="fs-3">{{ messages() }}</span>
            } @else if (inputType() === 'HST') {
                <span class="fs-3">Sure! Please upload the required documents, and we'll get started on generating your HST/GST Plausibility.</span>
            }
            @if (!isReadOnly()) {
                @if (showFIleInput()) {
                    <div class="file-upload" appDragDrop (onFileDropped)="onFileSelected($event,'DND')">
                        <div class="upload-icon">
                            <i class="fa-regular fa-cloud-arrow-up"></i>
                        </div>
                        <div class="file-wrapper">
                            <p class="text-link text-primary fw-medium m-0">
                                Click to upload
                                <span class="text-gray-6 fw-regular">or drag and drop</span>
                                <input type="file" multiple name="fileUpload" #fileUploader accept=".pdf"
                                       (change)="onFileSelected($event,'MANUAL')"/>
                            </p>
                            <p class="text-gray-6 fw-regular">PDF | Max 15 docs with total size of 25MB</p>
                        </div>
                    </div>
                }
                @if (hasLimitExceeded()) {
                    <span class="fs-12 text-error limit-error">Oops! It looks like you've exceeded the upload limit. You can upload up to 15 documents, with a total size of 25MB. Please adjust your files and give it another try.</span>
                }
                @if (selectedFile() && selectedFile()?.length) {
                    <ul class="list-style-none attached-list-items">
                        @for (file of selectedFile(); track $index; let index = $index) {
                            <li class="card p-2 shadow-none attached-list-item" title="{{ file?.name }}">
                            <span class="badge badge-circle badge-secondary icon-bordered-primary bw-4 badge-small">
                                <i class="fa-regular fa-cloud-arrow-up"></i>
                            </span>
                                <div class="flexbox-column w-auto flex-1 pt-1 overflow-hidden">
                                    <p class="text-ellipse">{{ file?.name }}</p>
                                </div>
                                <button mat-button class="button-text ms-auto mt-1" title="Delete Item"
                                        (click)="removeFile(index)">
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            </li>
                        }
                    </ul>
                }
                <div class="flexbox-row justify-content-start mt-3">
                    @if (hasProceedAction()) {
                        <button mat-button mat-stroked-button color="primary" class="button-default"
                                matTooltip="Continue with Existing Documents"
                                [disabled]="hasLimitExceeded()"
                                (click)="submitFiles('PROCEED')">
                            Continue
                        </button>
                        <button mat-button mat-flat-button color="primary" class="button-default"
                                matTooltip="Upload More Documents"
                                [disabled]="hasLimitExceeded()"
                                (click)="hasProceedAction.set(false)">
                            Upload
                        </button>
                    } @else {
                        <button mat-button mat-flat-button color="primary" class="button-default"
                                [disabled]="!hasFilesUploaded() || hasLimitExceeded()"
                                (click)="submitFiles('SUBMIT')">
                            Submit
                        </button>
                    }
                </div>
            } @else {
                @if (attachedFiles() && attachedFiles()?.length > 0) {
                    <ul class="list-style-none attached-list-items">
                        @for (file of attachedFiles(); track $index; let index = $index) {
                            <li class="card p-2 shadow-none attached-list-item" title="{{ file?.fileName }}">
                            <span class="badge badge-circle badge-secondary icon-bordered-primary bw-4 badge-small">
                                <i class="fa-regular fa-cloud-arrow-up"></i>
                            </span>
                                <div class="flexbox-column w-auto flex-1 pt-1 overflow-hidden">
                                    <p class="text-ellipse">{{ file?.fileName }}</p>
                                </div>
                            </li>

                        }
                    </ul>
                }
            }
        </div>
    }
    @case ('GENERAL_LEDGER') {
        @if (originalTbRows()?.length !== 0) {

            <div class="flexbox-column gap-16">
                <span class="fs-3">No problem, I just need few inputs from you to pull together the General Ledger Data. Please select the year
                    along with the criteria. You can select multiple options.
                </span>

                <div class="filter-option-outer">
                    <div class="year-field">
                        <mat-form-field class="fixed-label label-none" floatLabel="always" style="width: 100px">
                            <mat-label>select-year</mat-label>
                            <mat-select
                                    disableOptionCentering
                                    (selectionChange)="changeTbYear($event);setDraftSelection()"
                                    placeholder="Groups"
                                    [disabled]="isReadOnly()"
                                    [value]="selectedYear()"
                            >
                                @for (group of glData(); track $index) {
                                    <mat-option [value]="group?.year" (click)="changeYear(group);setDraftSelection()">
                                        {{ group?.year }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="ng-form-field group-select-field">
                        <label>Group</label>
                        <ng-select
                                [items]="groups()"
                                bindLabel="groupName"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                placeholder="Select Group"
                                [disabled]="isReadOnly()"
                                [(ngModel)]="selectedGroups"
                                [searchable]="true"
                                (change)="onGroupChange($event)"
                        >
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div
                                        class="multi-select-badge badge badge-small badge-pills badge-primary badge-border gap-2 me-1 justify-content-between"
                                        style="width: 70px"
                                        title="{{ item?.groupName }}"
                                        *ngFor="let item of items | slice : 0 : 1"
                                >
                                    <span class="text-ellipse">{{ item?.groupName }}</span>
                                    <button mat-button class="button-text" aria-hidden="true"
                                    (click)="!isReadOnly() && clear(item)"
                                    [disabled]="isReadOnly()">
                                    <i class="fa-regular fa-xmark text-error"></i>
                                    </button>
                                </div>
                                <span class="ng-value-label" *ngIf="items.length > 1">+{{ items.length - 1 }}
                                    more</span>
                            </ng-template>
                            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                                <label class="title m-0 text-ellipse d-block"
                                       title="{{ item?.groupName }}">{{ item?.groupName }}</label>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="ng-form-field sub-group-select-field">
                        <label>Sub group</label>
                        <ng-select
                                [items]="subGroups()"
                                bindLabel="subGroupName"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                placeholder="Select Sub group"
                                [(ngModel)]="selectedSubGroups"
                                [disabled]="isReadOnly()"
                                [searchable]="true"
                                (change)="onSubGroupChange($event);setDraftSelection()"
                        >
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div
                                        class="multi-select-badge badge badge-small badge-pills badge-primary badge-border gap-2 me-1 justify-content-between"
                                        style="width: 70px"
                                        title="{{ item?.subGroupName }}"
                                        *ngFor="let item of items | slice : 0 : 1"
                                >
                                    <span class="text-ellipse">{{ item?.subGroupName }}</span>
                                    <button mat-button class="button-text" aria-hidden="true"
                                    (click)="!isReadOnly() && clear(item)"
                                    [disabled]="isReadOnly()">
                                    <i class="fa-regular fa-xmark text-error"></i>
                                    </button>
                                </div>
                                <span class="ng-value-label" *ngIf="items?.length > 1">+{{ items?.length - 1 }}
                                    more</span>
                            </ng-template>
                            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                                <label class="title m-0 text-ellipse d-block"
                                       title="{{ item?.subGroupName }}">{{ item?.subGroupName }}</label>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="ng-form-field ls-select-field">
                        <label>Leadsheet</label>
                        <ng-select
                                [items]="lsAccountsInfo()"
                                bindLabel="lsName"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                placeholder="Select Leadsheet"
                                [(ngModel)]="selectedLs"
                                [disabled]="isReadOnly()"
                                [searchable]="true"
                                (change)="onLsChange($event)"
                        >
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div
                                        class="multi-select-badge badge badge-small badge-pills badge-primary badge-border gap-2 me-1 justify-content-between"
                                        style="width: 70px"
                                        title="{{ item?.lsName }} {{ item?.lsCode }}"
                                        *ngFor="let item of items | slice : 0 : 1"
                                >
                                    <span class="text-ellipse">{{ item?.lsName }} {{ item?.lsCode }}</span>
                                    <button mat-button class="button-text" aria-hidden="true"
                                    (click)="!isReadOnly() && clear(item)"
                                    [disabled]="isReadOnly()">
                                    <i class="fa-regular fa-xmark text-error"></i>
                                    </button>
                                </div>
                                <span class="ng-value-label" *ngIf="items.length > 1">+{{ items.length - 1 }}
                                    more</span>
                            </ng-template>
                            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                                <div
                                        class="flexbox-row gap-8 flex-nowrap overflow-hidden justify-content-between"
                                        title="{{ item?.lsName }} {{ item?.lsCode }}"
                                >
                                    <label class="title text-ellipse m-0 d-block">{{ item?.lsName }}</label>
                                    <span>{{ item?.lsCode }}</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="ng-form-field account-select-field">
                        <label>Accounts</label>
                        <ng-select
                                [items]="tbAccountsInfo()"
                                bindLabel="accountName"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                placeholder="Select Accounts"
                                [(ngModel)]="selectedAccounts"
                                [disabled]="isReadOnly()"
                                [searchable]="true"
                                (change)="onAccountsChange($event)"
                        >
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div
                                        class="multi-select-badge badge badge-small badge-pills badge-primary badge-border gap-2 me-1 justify-content-between"
                                        style="width: 70px"
                                        title="{{ item?.accountName }} {{ item?.finalAmount }}"
                                        *ngFor="let item of items | slice : 0 : 1"
                                >
                                    <span class="text-ellipse">{{ item?.accountName }} {{ item?.finalAmount }}</span>
                                    <button mat-button class="button-text" aria-hidden="true"
                                    (click)="!isReadOnly() && clear(item)"
                                    [disabled]="isReadOnly()">
                                    <i class="fa-regular fa-xmark text-error"></i>
                                    </button>
                                </div>
                                <span class="ng-value-label" *ngIf="items.length > 1">+{{ items.length - 1 }}
                                    more</span>
                            </ng-template>
                            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                                <div
                                        class="flexbox-row gap-8 flex-nowrap overflow-hidden justify-content-between"
                                        title="{{ item?.accountName }} {{ item?.finalAmount | number:'1.2-2' | minusSignToParenthesis}}"
                                >
                                    <label class="title text-ellipse m-0 d-block">{{ item?.accountName }}</label>
                                    <span>{{ item?.finalAmount | number:'1.2-2' | minusSignToParenthesis }}</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>

                    @if (!isReadOnly()) {
                        <div class="button-group gap-8 flex-nowrap ms-auto">
                            <button mat-button mat-flat-button color="secondary" class="button-default"
                                    (click)="clearSelection(true);setDraftSelection()">
                                Clear All
                            </button>
                            <button
                                    mat-button
                                    mat-flat-button
                                    color="primary"
                                    class="button-default"
                                    [disabled]=" !((selectedAccounts && selectedAccounts?.length > 0) ||
                                    (selectedLs && selectedLs?.length > 0) || (selectedSubGroups && selectedSubGroups?.length > 0)
                                    || (selectedGroups && selectedGroups?.length > 0)) "
                                    (click)="submitSelection()"
                            >
                                Submit
                            </button>
                        </div>
                    }
                </div>

                @if (selectedTbRows()?.length > 0) {
                    <div class="bot-engagement-table-outer">
                        <div
                                class="flex-table fixed-header w-100 bot-engagement-table mt-3"
                                (click)="$event.stopPropagation()"
                                style="overflow-y: auto"
                        >
                            <div class="flex-table-header">
                                <p class="ft-cell date-cell ps-2">Date</p>
                                <p class="ft-cell transaction-cell">Transaction type</p>
                                <p class="ft-cell width-100">Num</p>
                                <!--                            <p class="ft-cell acc-code-cell">Acc Code</p>-->
                                <p class="ft-cell acc-name-cell">Name</p>
                                <!--                            <p class="ft-cell ls-code-cell">Ls Code</p>-->
                                <p class="ft-cell des-cell">Memo/Description</p>
                                <p class="ft-cell text-right amount-cell">Amount</p>
                                <p class="ft-cell text-right balance-cell pe-2">Balance</p>
                            </div>

                            <div class="flex-table-body" (click)="$event.stopPropagation()">
                                @for (row of selectedTbRows(); track $index) {
                                    <div class="ft-row button-row beginning-balance">
                                        @if (row?.accountcode?.trim()?.length > 0) {
                                            <p class="ft-cell date-cell ps-2 fw-semibold"
                                               title="{{row?.accountcode}}">
                                                <span class="text-ellipse">{{ row?.accountcode }}</span>
                                            </p>
                                        }
                                        <p class="ft-cell total-title-cell ps-2 fw-semibold"
                                           title="{{ row?.accountname }}">
                                            <span class="text-ellipse">{{ row?.accountname }}</span>
                                        </p>
                                        <p class="ft-cell text-right balance-cell pe-2"></p>
                                    </div>
                                    @if ([1, 2, 3].includes(row?.fingroupid)) {
                                        <div class="ft-row button-row beginning-balance">
                                            <p class="ft-cell total-title-cell ps-2 fw-semibold"
                                               title="Beginning Balance">
                                                <span class="text-ellipse">Beginning Balance</span>
                                            </p>
                                            <p class="ft-cell text-right balance-cell pe-2 fw-semibold"
                                               title="{{ row?.opening_balance }}">
                                                {{ row?.opening_balance }}
                                            </p>
                                        </div>
                                    }
                                    @for (list of row?.transactions; track $index) {
                                        <div class="ft-row button-row">
                                            <p class="ft-cell date-cell ps-2" title="{{ list?.date }}">
                                                <span class="text-ellipse">{{ list?.date }}</span>
                                            </p>
                                            <p class="ft-cell transaction-cell" title="{{ list?.transactionType }}">
                                                <span class="text-ellipse">{{ list?.transactionType }}</span>
                                            </p>
                                            <p class="ft-cell width-100" title="{{ list?.num }}">
                                                <span class="text-ellipse">{{ list?.num }}</span>
                                            </p>
                                            <p class="ft-cell acc-name-cell" title="{{ list?.Name }}">
                                                <span class="text-ellipse">{{ list?.Name }}</span>
                                            </p>
                                            <p class="ft-cell des-cell" title="{{ list?.description }}">
                                                <span class="text-ellipse">{{ list?.description }}</span>
                                            </p>
                                            <p class="ft-cell text-right amount-cell" title="{{ list?.amount }}">
                                                <span class="text-ellipse">{{ list?.amount }}</span>
                                            </p>
                                            <p class="ft-cell text-right balance-cell pe-2" title="{{ list?.balance }}">
                                                <span class="text-ellipse">{{ list?.balance }}</span>
                                            </p>
                                        </div>
                                    }
                                    <div class="ft-row button-row total-balance">
                                        <p class="ft-cell total-title-cell ps-2"
                                           title="Total for {{ row?.accountname }}">
                                            <span class="text-ellipse">Total for {{ row?.accountname }}</span>
                                        </p>
                                        <p class="ft-cell text-right balance-cell pe-2"
                                           title="{{ row?.total_balance ?? '' }}">
                                            {{ row?.total_balance ?? "" }}
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="no-data-found " style="min-height: 200px">
                        <img draggable="false" src="/assets/images/ui-uplift-icons/global/empty-component-icon.svg"
                             alt="Icon"/>
                        <h6>Nothing selected yet</h6>
                    </div>
                }
            </div>
        } @else {
            <div class="no-data-found" style="min-height: 400px">
                <img draggable="false" src="/assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon"/>
                <h6>No records found!</h6>
            </div>
        }
    }
    @case ('CAAS_PREFERENCES') {
        @if (amortizationInputs()?.length > 0) {
            <div class="flexbox-column gap-16">
            <span class="fs-3">
                No problem, I just need few inputs from you to pull together the Amortization Schedule. Please select the respective appropriate categories
            </span>
                <div class="bot-engagement-table-outer">
                    <div class="flex-table fixed-header w-100 bot-engagement-table amortization-first-table card"
                         (click)="$event.stopPropagation()" style="overflow-y: auto;">
                        <div class="flex-table-header">
                            <p class="ft-header-cell align-items-end account-cell width-80 ps-2">Acc No</p>
                            <p class="ft-header-cell align-items-end des-cell width-200">Description</p>
                            <p class="ft-header-cell align-items-end category-cell width-200">Category</p>
                            <div class="ft-header-cell align-items-end menthod-cell width-200">
                                <div class="flexbox-row gap-4">
                                    <span>Method</span>
                                    <span class="custom-tooltip-block">
                                        <i class="fa-regular fa-circle-info text-primary"></i>
                                        <div class="flexbox-column gap-8 custom-tooltip amo-formula-tip">
                                            <!-- <span class="fs-3">Formulas for Calculating Amortization Value</span> -->
                                            <ul class="flexbox-column gap-0 ps-3">
                                                <li class="fs-10">
                                                    Straight Line = (Opening Balance (OB1) - Residual Value)/Useful Life
                                                </li>
                                                <li class="fs-10">
                                                    Decline = (Opening Balance (OB1) * (rate/100))
                                                </li>
                                                <li class="fs-10">
                                                    Sum of Years = (Useful Life(Useful Life + 1))/2
                                                </li>
                                                <li class="fs-10">
                                                     Sum of Years Digits = (Remaining life /Sum of Years) * (Opening Balance (OB1) - Residual Value)
                                                </li>
                                                <li class="fs-10">
                                                    Units of Production = ((Opening Balance (OB1) - Residual Value) / Estimated Production) * Units Produced
                                                </li>
                                            </ul>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <p class="ft-header-cell align-items-end h-year-rule-cell width-110">Half Year Rule</p>
                            <p class="ft-header-cell align-items-end text-right amount-cell width-100">Rate(%)</p>
                            <p class="ft-header-cell align-items-end text-right usefull-life-cell width-100">Useful
                                Life(in
                                years)</p>
                            <p class="ft-header-cell align-items-end text-right residual-cell width-150">Residual
                                Value</p>
                            <p class="ft-header-cell align-items-end text-right estimated-pro-cell width-150">Estimated
                                Production</p>
                            <p class="ft-header-cell align-items-end text-right units-pro-cell width-150">Units
                                Produced</p>
                            <p class="ft-header-cell align-items-end text-right remaining-cell width-100 pe-2">
                                Remaining Life(in years)
                            </p>
                        </div>
                        <div class="flex-table-body">
                            @for (row of amortizationInputs(); track $index; let index = $index) {
                                <div class="ft-row button-row">
                                    <p class="ft-cell account-cell width-80 ps-2" title="{{ row?.tbAccountCode }}">
                                        {{ row?.tbAccountCode }}
                                    </p>
                                    <p class="ft-cell des-cell width-200" title="{{ row?.tbAccountName }}">
                                        {{ row?.tbAccountName }}
                                    </p>
                                    <div class="ft-cell category-cell width-200" title="">
                                        <mat-form-field class="fixed-label form-field-smaller label-none w-100"
                                                        floatLabel="always">
                                            <mat-label>Category</mat-label>
                                            <mat-select
                                                    [disableOptionCentering]="true"
                                                    (selectionChange)="changeInputs($event, 'CATEGORY', index)"
                                                    value="{{ row?.categoryId }}"
                                                    [disabled]="isReadOnly()"
                                                    placeholder="Select"
                                            >
                                                @for (cat of categoryList(); track $index) {
                                                    <mat-option value="{{ cat?.categoryId }}"
                                                                title="{{ cat?.categoryName }}"
                                                    >{{ cat?.categoryName }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="ft-cell menthod-cell width-200" title="">
                                        <mat-form-field class="fixed-label form-field-smaller label-none w-100"
                                                        floatLabel="always">
                                            <mat-label>Method</mat-label>
                                            <mat-select
                                                    [disableOptionCentering]="true"
                                                    value="{{ row?.methodId }}"
                                                    [disabled]="isReadOnly()"
                                                    (selectionChange)="changeInputs($event, 'METHOD', index)"
                                                    placeholder="Select"
                                            >
                                                @for (method of methods(); track $index) {
                                                    <mat-option value="{{ method?.methodId }}"
                                                                title="{{ method?.methodName }}"
                                                    >{{ method?.methodName }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <p class="ft-cell h-year-rule-cell width-110" title="">
                                        <mat-form-field class="fixed-label form-field-smaller label-none w-100"
                                                        floatLabel="always">
                                            <mat-label>Half Year Rule</mat-label>
                                            <mat-select
                                                    [disableOptionCentering]="true"
                                                    [disabled]="isReadOnly()"
                                                    (selectionChange)="changeInputs($event, 'HALF_YEAR', index)"
                                                    value="{{ row?.halfYearRule }}"
                                                    placeholder="Select Half Year Rule"
                                            >
                                                <mat-option value="Yes">Yes</mat-option>
                                                <mat-option value="No">No</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </p>
                                    <div class="ft-cell text-right amount-cell width-100" title="">
                                        <mat-form-field
                                                aria-disabled="disable"
                                                class="fixed-label form-field-smaller label-none w-100"
                                                floatLabel="always"
                                        >
                                            <mat-label>Rate</mat-label>
                                            <input
                                                    matInput
                                                    value="{{ row?.rate }}"
                                                    (keydown)="formatTransformInput($event,true)"
                                                    (blur)="updateLineItems($event, 'RATE', index,row)"
                                                    placeholder="Rate"
                                                    [disabled]="isReadOnly()"
                                            />
                                        </mat-form-field>
                                    </div>
                                    <div class="ft-cell text-right usefull-life-cell width-100" title="">
                                        <mat-form-field
                                                aria-disabled="disable"
                                                class="fixed-label form-field-smaller label-none w-100"
                                                floatLabel="always"
                                        >
                                            <mat-label>Useful Life</mat-label>
                                            <input
                                                    matInput
                                                    placeholder="Useful Life"
                                                    (keydown)="transformCAASRow($event,true)"
                                                    (blur)="updateLineItems($event, 'UL', index,row)"
                                                    value="{{ row?.usefulLife }}"
                                                    [disabled]="isReadOnly()"
                                            />
                                        </mat-form-field>
                                    </div>
                                    <div class="ft-cell text-right residual-cell width-150" title="">
                                        @if (row?.methodId === 2) {
                                            <mat-form-field
                                                    aria-disabled="disable"
                                                    class="fixed-label form-field-smaller label-none w-100"
                                                    floatLabel="always"
                                            >
                                                <mat-label>Residual Value</mat-label>
                                                <input
                                                        matInput
                                                        placeholder="Residual Value"
                                                        [disabled]="true"
                                                        value="0.00"
                                                />
                                            </mat-form-field>
                                        } @else {
                                            <mat-form-field
                                                    aria-disabled="disable"
                                                    class="fixed-label form-field-smaller label-none w-100"
                                                    floatLabel="always"
                                            >
                                                <mat-label>Residual Value</mat-label>
                                                <input
                                                        matInput
                                                        placeholder="Residual Value"
                                                        (keydown)="transformCAASRow($event,true)"
                                                        [disabled]="isReadOnly()"
                                                        (blur)="updateLineItems($event, 'RV', index,row)"
                                                        value="{{ row?.residualValue }}"
                                                />
                                            </mat-form-field>
                                        }
                                    </div>
                                    <div class="ft-cell text-right estimated-pro-cell width-150" title="">
                                        @if (row?.methodId !== 4) {
                                            <mat-form-field
                                                    aria-disabled="disable"
                                                    class="fixed-label form-field-smaller label-none w-100"
                                                    floatLabel="always"
                                            >
                                                <mat-label>Estimated Production</mat-label>
                                                <input
                                                        matInput
                                                        placeholder="Estimated Production"
                                                        [disabled]="true"
                                                        value="0.00"
                                                />
                                            </mat-form-field>
                                        } @else {
                                            <mat-form-field
                                                    aria-disabled="disable"
                                                    class="fixed-label form-field-smaller label-none w-100"
                                                    floatLabel="always"
                                            >
                                                <mat-label>Estimated Production</mat-label>
                                                <input
                                                        matInput
                                                        placeholder="Estimated Production"
                                                        [disabled]="isReadOnly()"
                                                        (keydown)="transformCAASRow($event,true)"
                                                        (blur)="updateLineItems($event, 'EP', index,row)"
                                                        value="{{ row?.estimatedProduction }}"
                                                />
                                            </mat-form-field>
                                        }
                                    </div>
                                    <div class="ft-cell text-right units-pro-cell width-150" title="">
                                        @if (row?.methodId !== 4) {
                                            <mat-form-field
                                                    aria-disabled="disable"
                                                    class="fixed-label form-field-smaller label-none w-100"
                                                    floatLabel="always"
                                            >
                                                <mat-label>Units Produced</mat-label>
                                                <input
                                                        matInput
                                                        placeholder="Units Produced"
                                                        [disabled]="true"
                                                        value="0.00"
                                                />
                                            </mat-form-field>
                                        } @else {
                                            <mat-form-field
                                                    aria-disabled="disable"
                                                    class="fixed-label form-field-smaller label-none w-100"
                                                    floatLabel="always"
                                            >
                                                <mat-label>Units Produced</mat-label>
                                                <input
                                                        matInput
                                                        placeholder="Units Produced"
                                                        [disabled]="isReadOnly()"
                                                        (keydown)="transformCAASRow($event,true)"
                                                        (blur)="updateLineItems($event, 'UP', index,row)"
                                                        value="{{ row?.unitProduced }}"
                                                />
                                            </mat-form-field>
                                        }
                                    </div>
                                    <div class="ft-cell text-right remaining-cell width-100 pe-2" title="">
                                        @if (row?.methodId !== 5) {
                                            <mat-form-field
                                                    aria-disabled="disable"
                                                    class="fixed-label form-field-smaller label-none w-100"
                                                    floatLabel="always"
                                            >
                                                <mat-label>Remaining Life</mat-label>
                                                <input
                                                        matInput
                                                        placeholder="Remaining Life"
                                                        [disabled]="true"
                                                        value="0.00"
                                                />
                                            </mat-form-field>
                                        } @else {
                                            <mat-form-field
                                                    aria-disabled="disable"
                                                    class="fixed-label form-field-smaller label-none w-100"
                                                    floatLabel="always"
                                            >
                                                <mat-label>Remaining Life</mat-label>
                                                <input
                                                        matInput
                                                        placeholder="Remaining Life"
                                                        [disabled]="isReadOnly()"
                                                        (keydown)="transformCAASRow($event,true)"
                                                        (blur)="updateLineItems($event, 'RL', index,row)"
                                                        value="{{ row?.remainingLife }}"
                                                />
                                            </mat-form-field>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    @if (!isReadOnly()) {
                        <div class="flexbox-row justify-content-end mt-3">
                            <button mat-button mat-flat-button color="primary" class="button-default"
                                    [disabled]="!hasValidInputs()"
                                    (click)="submitAmortizationInputs('SAVED')">
                                Submit
                            </button>
                        </div>
                    }
                </div>
            </div>
        } @else {
            <div class="flexbox-column gap-16">
                <span class="fs-3">Amortization inputs could not be generated due to an issue with account mapping.
                    Please verify that all accounts are mapped correctly with the appropriate Map Number.
                    Alternatively, there may be an issue with the server. If the problem persists, contact technical support.</span>
            </div>
        }
    }
    @case ('CAAS_SCHEDULE') {
        @if (amortizationSchedule()?.length > 0) {
            <div class="flexbox-column gap-16">
                <span class="fs-3">Here's the amortization schedule for you</span>

                <div class="bot-engagement-table-outer card overflow-auto">
                    <div class="flex-table fixed-header bot-engagement-table amortization-table">
                        <div class="flex-table-header flex-nowrap">
                            <p class="ft-header-cell justify-content-center width-230 ps-2">Description</p>
                            <div class="flexbox-column gap-0 flex-nowrap">
                                <div class="flexbox-row gap-0">
                                    <p class="ft-header-cell width-470 justify-content-center border-start">Original
                                        Cost</p>
                                    <p class="ft-header-cell width-450 justify-content-center border-start">Accumulated
                                        Amortization</p>
                                    <p class="ft-header-cell width-430 justify-content-center border-start">Net Book
                                        Value</p>
                                    <p class="ft-header-cell width-320 justify-content-center border-start pe-5">
                                        Depreciation</p>
                                </div>
                                <div class="flexbox-row gap-0 align-items-stretch">

                                    <p class="ft-header-cell category-cell border-start width-150 text-center ps-2 tooltip-block">
                                        <span class="title">Opening Balance (OB1)</span>
                                        <button mat-button class="text-button" matTooltip="Prior Year From Trial Balance">
                                            <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>
                                    <p class="ft-header-cell adjustment-cell border-start width-160 text-center tooltip-block">
                                        <span class="title">Additions/ Adjustments (ADD)</span>
                                        <button mat-button class="text-button" matTooltip="Debits From General Ledger">
                                            <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>
                                    <p class="ft-header-cell disposition-cell border-start width-160 text-center tooltip-block">
                                        <span class="title">Disposition/ Adjustments (DIS)</span>
                                        <button mat-button class="text-button" matTooltip="Credits From General Ledger">
                                            <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>
                                    <p class="ft-header-cell closing-balance-cell border-start text-center width-150 tooltip-block">
                                        <span class="title">Closing Balance (CB1)</span>
                                        <button mat-button class="text-button" matTooltip="CB1 = OB1 + ADD - DIS">
                                            <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>


                                    <p class="ft-header-cell border-start tooltip-block opening-balance-cell text-center border-start width-150">
                                        <span class="title">Opening Balance (OB2)</span>
                                        <button mat-button class="text-button"
                                                matTooltip="Current Year From Trial Balance">
                                                <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>
                                    <p class="ft-header-cell border-start tooltip-block amortization-cell text-center width-150">
                                        <span class="title ">Amortization<br>(A)</span>
                                    </p>
                                    <p class="ft-header-cell border-start tooltip-block closing-b-cb text-center width-150">
                                        <span class="title">Closing Balance<br>(CB2)</span>
                                        <button mat-button class="text-button" matTooltip="CB2 = OB2 + A">
                                            <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>

                                    <p class="ft-header-cell border-start tooltip-block current-year-cell text-center width-140">
                                        <span class="title">Current Year<br/>(CY)</span>
                                        <button mat-button class="text-button" matTooltip="CY = CB1 - CB2">
                                            <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>
                                    <p class="ft-header-cell border-start tooltip-block prev-year-cell text-center width-140">
                                        <span class="title">Previous Year<br/>(PY)</span>
                                        <button mat-button class="text-button" matTooltip="PY = OB1 - OB2">
                                            <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>


                                    <p class="ft-header-cell border-start tooltip-block tb-bal-cell text-center width-150">
                                        <span class="title">Trial Balance<br>(TB)</span>
                                        <button mat-button class="text-button"
                                                matTooltip="Difference Of Prior Year and Final Amount From Trail Balance">
                                                <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>
                                    <p class="ft-header-cell border-start tooltip-block under-over-cell text-center width-170 pe-5">
                                        <span class="title">Under/<br>Over (UO)</span>
                                        <button mat-button class="text-button" matTooltip="UO = A- TB">
                                            <i class="fa-regular fa-circle-info"></i>
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="flex-table-body" (click)="$event.preventDefault();">
                            @for (row of amortizationSchedule(); track $index; let index = $index) {
                                @if (row?.rowType === 'TB') {
                                    <mat-accordion multi="true">
                                        <mat-expansion-panel class="br-0" [expanded]="row?.isExpanded"
                                                             (closed)="closePanel(row)"
                                                             (opened)="openPanel(row)">
                                            <mat-expansion-panel-header class="p-0 border-bottom br-0">
                                                <div class="ft-row button-row" (click)="$event.stopPropagation()">
                                                    <p class="ft-cell account-cell width-80 ps-2"
                                                       title="{{row?.accNo}}">
                                                        {{ row?.accNo }}
                                                    </p>
                                                    <p class="ft-cell des-cell width-150 border-start"
                                                       title="{{row?.description}}">
                                                        {{ row?.description }}
                                                    </p>

                                                    <p class="ft-cell width-150 border-start text-right"
                                                       title="{{ row?.openingBalOne }}">
                                                        {{ row?.openingBalOne }}
                                                    </p>
                                                    <p class="ft-cell adjustment-cell width-160 text-right border-start"
                                                       title="{{ row?.addAdj }}">
                                                        <mat-form-field
                                                                aria-disabled="disable"
                                                                class="form-item fixed-label form-field-smaller label-none w-100"
                                                                floatLabel="always"
                                                        >
                                                            <mat-label>Units Produced</mat-label>
                                                            <input
                                                                    matInput
                                                                    placeholder="Add"
                                                                    id="ADD-{{ index }}"
                                                                    [disabled]="isReadOnly()"
                                                                    (keydown)="transformCAASRow($event)"
                                                                    (blur)="updateCAASRow($event, 'ADD', index)"
                                                                    value="{{ row?.addAdj }}"
                                                            />
                                                        </mat-form-field>
                                                    </p>
                                                    <p
                                                            class="ft-cell disposition-cell border-start width-160 text-right"
                                                            title="{{ row?.disAdj }}"
                                                    >
                                                        <mat-form-field
                                                                aria-disabled="disable"
                                                                class="form-item form-field-smaller fixed-label label-none w-100"
                                                                floatLabel="always"
                                                        >
                                                            <mat-label>Units Produced</mat-label>
                                                            <input
                                                                    matInput
                                                                    placeholder="Add"
                                                                    [disabled]="isReadOnly()"
                                                                    (keydown)="transformCAASRow($event)"
                                                                    (blur)="updateCAASRow($event, 'DIS', index)"
                                                                    value="{{ row?.disAdj }}"
                                                            />
                                                        </mat-form-field>
                                                    </p>
                                                    <p class="ft-cell closing-balance-cell text-right width-150 border-start"
                                                       title="{{ row?.closingBal }}">
                                                        {{ row?.closingBal }}
                                                    </p>

                                                    <p
                                                            class="ft-cell opening-balance-cell text-right width-150 border-start"
                                                            title="{{ row?.openingBalTb }}"
                                                    >
                                                        {{ row?.openingBalTb }}
                                                    </p>
                                                    <p class="ft-cell amortization-cell text-right width-150 border-start"
                                                       title="{{ row?.amortization }}">
                                                        {{ row?.amortization }}
                                                    </p>
                                                    <p class="ft-cell closing-b-cb text-right width-150 border-start"
                                                       title="{{ row?.closingBalTb }}">
                                                        {{ row?.closingBalTb }}
                                                    </p>

                                                    <p class="ft-cell current-year-cell width-140 text-right border-start"
                                                       title="{{ row?.currYear }}">
                                                        {{ row?.currYear }}
                                                    </p>
                                                    <p class="ft-cell prev-year-cell width-140 text-right border-start"
                                                       title="{{ row?.prevYear }}">
                                                        {{ row?.prevYear }}
                                                    </p>

                                                    <p class="ft-cell tb-bal-cell width-150 text-right border-start"
                                                       title="{{ row?.balTb }}">
                                                        <mat-form-field
                                                                aria-disabled="disable"
                                                                class="fixed-label label-none form-field-smaller w-100"
                                                                floatLabel="always"
                                                        >
                                                            <mat-label>Units Produced</mat-label>
                                                            <input
                                                                    matInput
                                                                    placeholder="Add"
                                                                    [disabled]="isReadOnly()"
                                                                    (keydown)="transformCAASRow($event)"
                                                                    (blur)="updateCAASRow($event, 'TB', index)"
                                                                    value="{{ row?.balTb }}"
                                                            />
                                                        </mat-form-field>
                                                    </p>
                                                    <p class="ft-cell under-over-cell width-170 text-right border-start pe-5"
                                                       title="{{ row?.underOver }}">
                                                        {{ row?.underOver }}
                                                    </p>
                                                </div>
                                            </mat-expansion-panel-header>

                                            <ng-template matExpansionPanelContent>
                                                <mat-tab-group class="card box-shadow-none" mat-stretch-tabs="false"
                                                               (selectedIndexChange)="onTabChange($event,row?.calculations?.method)"
                                                               mat-align-tabs="start">
                                                    <mat-tab label="First">
                                                        <ng-template mat-tab-label>
                                                            <span>Amortization Calculation</span>
                                                        </ng-template>
                                                        @defer (on immediate) {
                                                            <ul class="list-style-none flexbox-row gap-16 p-2">
                                                                <li class="flexbox-row gap-8">Account Name:<span
                                                                        class="fw-semibold">{{ row?.description }}</span>
                                                                </li>
                                                                <li class="flexbox-row gap-8">Method:<span
                                                                        class="fw-semibold">{{ row?.calculations?.method }}</span>
                                                                </li>
                                                                <li class="flexbox-row gap-8">Half Year Rule:<span
                                                                        class="fw-semibold">{{ row?.calculations?.halfYearRule }}</span>
                                                                </li>
                                                            </ul>
                                                            <div class="flex-table fixed-header w-100 bot-engagement-table card"
                                                                 style="overflow-y: auto;max-height:400px;">
                                                                <div class="flex-table-header">
                                                                    <p class="ft-header-cell width-150 ps-2">Date</p>
                                                                    <p class="ft-header-cell width-250">Description</p>
                                                                    <p class="ft-header-cell width-120 text-right">
                                                                        Amount</p>
                                                                    <p class="ft-header-cell width-120 text-right pe-2">
                                                                        Amortization</p>
                                                                    <p class="ft-header-cell width-120 text-right pe-2">
                                                                        No. of Months</p>
                                                                    <p class="ft-header-cell width-120 text-right pe-2">
                                                                        Months in use</p>
                                                                    <p class="ft-header-cell width-120 text-right pe-2">
                                                                        Useful life</p>
                                                                    <p class="ft-header-cell width-120 text-right pe-2">
                                                                        Residual Value</p>
                                                                </div>
                                                                <div class="flex-table-body">
                                                                    @for (detail of row?.calculations?.details; track $index; let detailIndex = $index) {
                                                                        <div class="ft-row button-row">
                                                                            @if (detail?.rowType === 'ADD' || detail?.rowType === 'DIS') {
                                                                                <p class="ft-cell width-150 ps-2"
                                                                                   title="{{ detail?.date }}">
                                                                                    {{ detail?.date }}
                                                                                </p>
                                                                            } @else {
                                                                                <p class="ft-cell width-150 ps-2">
                                                                                </p>
                                                                            }
                                                                            <p class="ft-cell width-250"
                                                                               title="{{ detail?.description }}">
                                                                                {{ detail?.description }}
                                                                            </p>
                                                                            @if (detail?.rowType !== 'TOTAL') {
                                                                                @if (detail?.rowType !== 'OPENING') {
                                                                                    <p class="ft-cell width-120 text-right"
                                                                                       title="{{ detail?.amount }}">
                                                                                        <mat-form-field
                                                                                                aria-disabled="disable"
                                                                                                class="form-item fixed-label form-field-smaller label-none w-100"
                                                                                                floatLabel="always">
                                                                                            <mat-label>Amount
                                                                                            </mat-label>
                                                                                            <input
                                                                                                    matInput
                                                                                                    placeholder="Add"
                                                                                                    id="DETAIL-{{ index }}"
                                                                                                    [disabled]="isReadOnly()"
                                                                                                    (keydown)="transformCAASRow($event)"
                                                                                                    (blur)="updateAmountInDetail($event, detail?.rowType, detailIndex,index)"
                                                                                                    value="{{ detail?.amount }}"
                                                                                            />
                                                                                        </mat-form-field>
                                                                                    </p>
                                                                                } @else {
                                                                                    <p class="ft-cell width-120 text-right"
                                                                                       title="{{ detail?.amount }}">
                                                                                        {{ detail?.amount }}
                                                                                    </p>
                                                                                }
                                                                            } @else {
                                                                                <p class="ft-cell width-120 text-right">
                                                                                </p>
                                                                            }
                                                                            <p class="ft-cell width-120 text-right pe-2"
                                                                               title="{{ detail?.amortization }}">
                                                                                {{ detail?.amortization }}
                                                                            </p>
                                                                            @if (detail?.rowType === 'ADD' || detail?.rowType === 'DIS') {
                                                                                <p class="ft-cell width-120 text-right pe-2"
                                                                                   title="{{ detail?.months }}">
                                                                                    {{ detail?.months }}
                                                                                </p>
                                                                                <p class="ft-cell width-120 text-right pe-2"
                                                                                   title="{{ detail?.monthInUse }}">
                                                                                    {{ detail?.monthInUse }}
                                                                                </p>
                                                                                <p class="ft-cell width-120 text-right pe-2"
                                                                                   title="{{ detail?.usefulLife }}">
                                                                                    {{ detail?.usefulLife }}
                                                                                </p>
                                                                                <p class="ft-cell width-120 text-right pe-2"
                                                                                   title="{{ detail?.residualValue }}">
                                                                                    {{ detail?.residualValue }}
                                                                                </p>
                                                                            }
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    </mat-tab>
                                                    <mat-tab label="Second">
                                                        <ng-template mat-tab-label>
                                                            <span>Formulae</span>
                                                        </ng-template>
                                                        @defer (on immediate) {
                                                            <div class="flexbox-column gap-8 pt-2 ps-1">
                                                                <markdown [katex]="true" [katexOptions]="katexInfo()" [data]="showMethodFormulae()">
                                                                </markdown>
                                                            </div>
                                                        }
                                                    </mat-tab>
                                                    <mat-tab label="Third">
                                                        <ng-template mat-tab-label>
                                                            <span>General Ledger</span>
                                                        </ng-template>
                                                        <div class="bot-engagement-table-outer">
                                                            <div
                                                                    class="flex-table fixed-header w-100 bot-engagement-table mt-3"
                                                                    (click)="$event.stopPropagation()"
                                                                    style="overflow-y: auto"
                                                            >
                                                                <div class="flex-table-header">
                                                                    <p class="ft-cell date-cell ps-2">Date</p>
                                                                    <p class="ft-cell transaction-cell">Transaction type</p>
                                                                    <p class="ft-cell width-100">Num</p>
                                                                    <p class="ft-cell acc-name-cell">Name</p>
                                                                    <p class="ft-cell des-cell">Memo/Description</p>
                                                                    <p class="ft-cell text-right amount-cell">Amount</p>
                                                                </div>

                                                                <div class="flex-table-body" (click)="$event.stopPropagation()">
                                                                    @for (lineItem of row?.generalLedger; track $index) {
                                                                        <div class="ft-row button-row">
                                                                            <p class="ft-cell date-cell ps-2" title="{{ lineItem?.Date }}">
                                                                                <span class="text-ellipse">{{ lineItem?.Date }}</span>
                                                                            </p>
                                                                            <p class="ft-cell transaction-cell" title="{{ lineItem?.['Transaction Type'] }}">
                                                                                <span class="text-ellipse">{{ lineItem?.["Transaction Type"] }}</span>
                                                                            </p>
                                                                            <p class="ft-cell acc-name-cell" title="{{ lineItem?.['Memo/Description'] }}">
                                                                                <span class="text-ellipse">{{ lineItem?.['Memo/Description'] }}</span>
                                                                            </p>
                                                                            <p class="ft-cell des-cell" title="{{ lineItem?.AccountName }}">
                                                                                <span class="text-ellipse">{{ lineItem?.AccountName }}</span>
                                                                            </p>
                                                                            <p class="ft-cell text-right amount-cell" title="{{ lineItem?.Amount }}">
                                                                                <span class="text-ellipse">{{ lineItem?.Amount }}</span>
                                                                            </p>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </mat-tab>
                                                </mat-tab-group>
                                            </ng-template>

                                        </mat-expansion-panel>
                                    </mat-accordion>
                                } @else {
                                    <div class="ft-row button-row">
                                        <p class="ft-cell width-80 ps-2 fw-semibold" title="{{ row?.accNo }}">
                                            {{ row?.accNo }}
                                        </p>
                                        <p class="ft-cell width-150 border-start fw-semibold"
                                           title="{{ row?.description }}">
                                            {{ row?.description }}
                                        </p>

                                        <p class="ft-cell width-150 text-right fw-semibold border-start"
                                           title="{{ row?.openingBalOne }}">
                                            {{ row?.openingBalOne }}
                                        </p>
                                        <p
                                                class="ft-cell adjustment-cell width-160 text-right fw-semibold border-start pe-3"
                                                title="{{ row?.addAdj }}"
                                        >
                                            {{ row?.addAdj }}
                                        </p>
                                        <p
                                                class="ft-cell disposition-cell width-160 text-right fw-semibold border-start pe-3"
                                                title="{{ row?.disAdj }}"
                                        >
                                            {{ row?.disAdj }}
                                        </p>
                                        <p
                                                class="ft-cell closing-balance-cell text-right fw-semibold border-start width-150"
                                                title="{{ row?.closingBal }}"
                                        >
                                            {{ row?.closingBal }}
                                        </p>

                                        <p
                                                class="ft-cell opening-balance-cell text-right fw-semibold width-150 border-start"
                                                title="{{ row?.openingBalTb }}"
                                        >
                                            {{ row?.openingBalTb }}
                                        </p>
                                        <p
                                                class="ft-cell amortization-cell text-right fw-semibold width-150 border-start"
                                                title="{{ row?.amortization }}"
                                        >
                                            {{ row?.amortization }}
                                        </p>
                                        <p
                                                class="ft-cell closing-b-cb text-right fw-semibold width-150 border-start"
                                                title="{{ row?.closingBalTb }}"
                                        >
                                            {{ row?.closingBalTb }}
                                        </p>

                                        <p
                                                class="ft-cell current-year-cell width-140 text-right fw-semibold border-start"
                                                title="{{ row?.currYear }}"
                                        >
                                            {{ row?.currYear }}
                                        </p>
                                        <p
                                                class="ft-cell prev-year-cell width-140 text-right fw-semibold border-start"
                                                title="{{ row?.prevYear }}"
                                        >
                                            {{ row?.prevYear }}
                                        </p>

                                        <p
                                                class="ft-cell tb-bal-cell width-150 text-right fw-semibold pe-3 border-start"
                                                title="{{ row?.balTb }}"
                                        >
                                            {{ row?.balTb }}
                                        </p>
                                        <p
                                                class="ft-cell under-over-cell width-170 text-right fw-semibold border-start pe-5"
                                                title="{{ row?.underOver }}"
                                        >
                                            {{ row?.underOver }}
                                        </p>
                                    </div>
                                }
                            }
                        </div>
                    </div>
                </div>

                @if (adjustmentEntries()?.length > 0) {
                    <div class="bot-engagement-table-outer post-entry-tbl">
                        <div class="flex-table fixed-header w-100 bot-engagement-table card" style="overflow-y: auto">
                            <div class="flex-table-header">
                                <p class="ft-header-cell width-80 ps-2">Acc No</p>
                                <p class="ft-header-cell width-250">Description</p>
                                <p class="ft-header-cell width-120 text-right">Debit</p>
                                <p class="ft-header-cell width-120 text-right pe-2">Credit</p>
                            </div>
                            <div class="flex-table-body">
                                @for (row of adjustmentEntries(); track $index) {
                                    <div class="ft-row button-row">
                                        <p class="ft-cell width-80 ps-2" title="{{ row?.accNo }}">
                                            {{ row?.accNo }}
                                        </p>
                                        <p class="ft-cell width-250" title="{{ row?.description }}">
                                            {{ row?.description }}
                                        </p>
                                        <p class="ft-cell width-120 text-right" title="{{ row?.debit }}">
                                            {{ row?.debit }}
                                        </p>
                                        <p class="ft-cell width-120 text-right pe-2" title="{{ row?.credit }}">
                                            {{ row?.credit }}
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    @if (inValidEntries() && inValidEntries()?.length > 0) {
                        <span class="fs-12 text-error">
                        The account(s) "{{ inValidEntries()?.join(',') }}" are either not available
                            in the Trial Balance or have not been correctly mapped to the appropriate
                             Amortization/Depreciation accounts. Please review the accounts before posting an entry
                    </span>
                    }
                }

            </div>
        } @else {
            <div class="flexbox-column gap-16">
                <span class="fs-3">
                    The Amortization Schedule Table could not be generated due to incomplete account mapping with the respective amortization accounts,
                    or the necessary accounts may not be available in the Trial Balance.
                    Please review the mappings and try again. If the issue persists, kindly report a bug.
                </span>
            </div>
        }
    }
    @case ('LAS') {
        <div class="flexbox-column gap-16">
            @if (this.hasMissingInputs()) {
                <span class="fs-3">{{ messages() }}</span>
                <div class="flexbox-row bot-response-body align-items-end pb-1">
                    <mat-form-field class="fixed-label bot-form-field" floatLabel="always">
                        <mat-label>Frequency</mat-label>
                        <mat-select [formControl]="frequencyCtrl">
                            @for (frequency of frequencyList(); track frequency?.value) {
                                <mat-option [value]="frequency?.value">{{ frequency?.label }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="fixed-label bot-form-field" floatLabel="always">
                        <mat-label>Interest rate</mat-label>
                        <input
                                matInput
                                placeholder="Interest rate"
                                (keydown)="transformLAS($event)"
                                (blur)="updateLAS($event, 'INTEREST')"
                                [formControl]="interestCtrl"
                                maxlength="25"
                                autocomplete="off"
                        />
                    </mat-form-field>
                    <app-countable-date class="date-width"
                            (selectedDate)="dateChanged($event)"
                            [label]="'Loan Start Date'" [placeholderText]="'MM/DD/YYYY'"
                            [isRequired]="true"
                            [inputDate]="transformedLoanDate()"></app-countable-date>
                    <mat-form-field class="fixed-label bot-form-field" floatLabel="always">
                        <mat-label>Principal Amount</mat-label>
                        <input
                                matInput
                                placeholder="Principal Amount"
                                (keydown)="transformLAS($event)"
                                (blur)="updateLAS($event, 'PRINCIPAL')"
                                [formControl]="principalCtrl"
                                maxlength="25"
                                autocomplete="off"
                        />
                    </mat-form-field>
                    <mat-form-field class="fixed-label bot-form-field" floatLabel="always">
                        <mat-label>Loan Tenure</mat-label>
                        <input
                                matInput
                                placeholder="Loan Tenure"
                                (keydown)="transformLASNumber($event)"
                                [formControl]="loanTenure"
                                maxlength="25"
                                autocomplete="off"
                        />
                    </mat-form-field>
                    @if (!isReadOnly()) {
                        <div class="flexbox-row justify-content-end mt-3">
                            <button mat-button mat-flat-button color="primary" class="button-default"
                                    [disabled]="isReadOnly() || !frequencyCtrl.value || !interestCtrl.value || !loanStartDate() || !principalCtrl.value || !loanTenure.value"
                                    (click)="submitLAS()">Submit
                            </button>
                        </div>
                    }
                </div>
            } @else {
                @if (messages()) {
                    <span class="fs-3">{{ messages() }}</span>
                } @else {
                    <span class="fs-3"> Sure! Please upload the required documents, and we'll get started on generating your Loan Amortization Schedule.</span>
                }
                @if (!isReadOnly()) {
                    @if (showFIleInput()) {
                        <div class="file-upload" appDragDrop (onFileDropped)="onFileSelected($event,'DND',false)">
                            <div class="upload-icon">
                                <i class="fa-regular fa-cloud-arrow-up"></i>
                            </div>
                            <div class="file-wrapper">
                                <p class="text-link text-primary fw-medium m-0">
                                    Click to upload
                                    <span class="text-gray-6 fw-regular">or drag and drop</span>
                                    <input type="file" name="fileUpload" #fileUploader accept="*"
                                           (change)="onFileSelected($event,'MANUAL',false)"/>
                                </p>
                                <p class="text-gray-6 fw-regular">one file with total size of 25MB</p>
                            </div>
                        </div>
                    }
                    @if (hasLimitExceeded()) {
                        <span class="fs-12 text-error limit-error">Oops! It looks like you've exceeded the upload limit. You can upload only one document, with a total size of 25MB. Please adjust your file and give it another try.</span>
                    }
                    @if (selectedFile() && selectedFile()?.length) {
                        <ul class="list-style-none attached-list-items">
                            @for (file of selectedFile(); track file; let index = $index) {
                                <li class="card p-2 shadow-none attached-list-item" title="{{ file?.name }}">
                            <span class="badge badge-circle badge-secondary icon-bordered-primary bw-4 badge-small">
                                <i class="fa-regular fa-file text-primary"></i>
                            </span>
                                    <div class="flexbox-column w-auto flex-1 pt-1 overflow-hidden">
                                        <p class="text-ellipse">{{ file?.name }}</p>
                                    </div>
                                    <button mat-button class="button-text ms-auto mt-1" title="Delete Item"
                                            (click)="removeFile(index)">
                                        <i class="fa-regular fa-trash-can fs-14"></i>
                                    </button>
                                </li>
                            }
                        </ul>
                    }
                    <div class="flexbox-row justify-content-start mt-3">
                        @if (hasProceedAction()) {
                            <button mat-button mat-stroked-button color="primary" class="button-default"
                                    matTooltip="Continue with Existing Documents"
                                    [disabled]="hasLimitExceeded()"
                                    (click)="submitFiles('PROCEED')">
                                Continue
                            </button>
                            <button mat-button mat-flat-button color="primary" class="button-default"
                                    matTooltip="Upload More Documents"
                                    [disabled]="hasLimitExceeded()"
                                    (click)="hasProceedAction.set(false)">
                                Upload
                            </button>
                        } @else {
                            <button mat-button mat-flat-button color="primary" class="button-default"
                                    [disabled]="!hasFilesUploaded() || hasLimitExceeded()"
                                    (click)="submitFiles('SUBMIT')">
                                Submit
                            </button>
                        }
                    </div>
                } @else {
                    @if (attachedFiles() && attachedFiles()?.length > 0) {
                        <ul class="list-style-none attached-list-items">
                            @for (file of attachedFiles(); track file; let index = $index) {
                                <li class="card p-2 shadow-none attached-list-item" title="{{ file?.fileName }}">
                            <span class="badge badge-circle badge-secondary icon-bordered-primary bw-4 badge-small">
                                <i class="fa-regular fa-file text-primary"></i>
                            </span>
                                    <div class="flexbox-column w-auto flex-1 pt-1 overflow-hidden">
                                        <p class="text-ellipse">{{ file?.fileName }}</p>
                                    </div>
                                </li>

                            }
                        </ul>
                    }
                }
            }
        </div>
    }
    @case ('RECONCILIATION') {
        <div class="flexbox-column gap-16">
                @if (!isReadOnly()) {
                    @if (showFIleInput() || this.hasNoValidRecon()) {
                        <span class="fs-3">{{ messages() }}</span>
                        <div class="flexbox-row bot-response-body align-items-end pb-1">
                            <mat-form-field class="fixed-label bot-form-field" floatLabel="always">
                                <mat-label>Trial Balance Account</mat-label>
                                <mat-select [formControl]="tbAccCtrl" placeholder="select account">
                                    @for (account of tbAccounts(); track account?.trialBalanceId) {
                                        <mat-option [value]="account?.accountUUID">{{ account?.accountName }}
                                            ({{ account.finalAmount }})
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        @if(plaidInstitutions()?.length > 0) {
                            <div class="flexbox-row bot-response-body align-items-end pb-1">
                                <mat-form-field class="fixed-label bot-form-field" floatLabel="always">
                                    <mat-label>Client Banking Accounts</mat-label>
                                    <mat-select [formControl]="plaidAccCtrl">
                                        @for (institution of plaidInstitutions(); track institution?.id) {
                                            <mat-optgroup [label]="institution.institutionName">
                                                @for (account of institution?.plaidAccounts; track account?.id) {
                                                    <mat-option [value]="account?.id">{{ account?.name }}</mat-option>
                                                }
                                            </mat-optgroup>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        } @else {
                            <div class="file-upload" appDragDrop (onFileDropped)="onFileSelected($event,'DND',false)">
                                <div class="upload-icon">
                                    <i class="fa-regular fa-cloud-arrow-up"></i>
                                </div>
                                <div class="file-wrapper">
                                    <p class="text-link text-primary fw-medium m-0">
                                        Click to upload
                                        <span class="text-gray-6 fw-regular">or drag and drop</span>
                                        <input type="file" name="fileUpload" #fileUploader accept="*"
                                               (change)="onFileSelected($event,'MANUAL',false)"/>
                                    </p>
                                    <p class="text-gray-6 fw-regular">one file with total size of 25MB</p>
                                </div>
                            </div>
                        }

                    }
                    @if (hasLimitExceeded()) {
                        <span class="fs-12 text-error limit-error">Oops! It looks like you've exceeded the upload limit. You can upload only one document, with a total size of 25MB. Please adjust your file and give it another try.</span>
                    }
                    @if (selectedFile() && selectedFile()?.length) {
                        <ul class="list-style-none attached-list-items">
                            @for (file of selectedFile(); track $index; let index = $index) {
                                <li class="card p-2 shadow-none attached-list-item" title="{{ file?.name }}">
                            <span class="badge badge-circle badge-secondary icon-bordered-primary bw-4 badge-small">
                                <i class="fa-regular fa-file text-primary"></i>
                            </span>
                                    <div class="flexbox-column w-auto flex-1 pt-1 overflow-hidden">
                                        <p class="text-ellipse">{{ file?.name }}</p>
                                    </div>
                                    <button mat-button class="button-text ms-auto mt-1" title="Delete Item"
                                            (click)="removeFile(index)">
                                        <i class="fa-regular fa-trash-can fs-14"></i>
                                    </button>
                                </li>
                            }
                        </ul>
                    }
                    <div class="flexbox-row justify-content-start mt-3">
                        @if (hasProceedAction()) {
                            <button mat-button mat-stroked-button color="primary" class="button-default"
                                    matTooltip="Continue with Existing Documents"
                                    [disabled]="hasLimitExceeded()"
                                    (click)="submitFiles('PROCEED')">
                                Continue
                            </button>
                            <button mat-button mat-flat-button color="primary" class="button-default"
                                    matTooltip="Upload More Documents"
                                    [disabled]="hasLimitExceeded()"
                                    (click)="hasProceedAction.set(false)">
                                Upload
                            </button>
                        } @else {
                            <button mat-button mat-flat-button color="primary" class="button-default"
                                    [disabled]="!((selectedFile()?.length > 0) && (tbAccCtrl.value || plaidAccCtrl.value))"
                                    (click)="submitRecon()">
                                Submit
                            </button>
                        }
                    </div>
                } @else {
                    <span class="fs-3">{{ messages() }}</span>
                    <mat-form-field class="fixed-label bot-form-field" floatLabel="always">
                        <mat-label>Trial Balance Account</mat-label>
                        <mat-select [formControl]="tbAccCtrl" placeholder="select account">
                            @for (account of tbAccounts(); track account?.trialBalanceId) {
                                <mat-option [value]="account?.accountUUID">{{ account?.accountName }}
                                    ({{ account.finalAmount }})
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (attachedFiles() && attachedFiles()?.length > 0) {
                        <ul class="list-style-none attached-list-items">
                            @for (file of attachedFiles(); track $index; let index = $index) {
                                <li class="card p-2 shadow-none attached-list-item" title="{{ file?.fileName }}">
                            <span class="badge badge-circle badge-secondary icon-bordered-primary bw-4 badge-small">
                                <i class="fa-regular fa-file text-primary"></i>
                            </span>
                                    <div class="flexbox-column w-auto flex-1 pt-1 overflow-hidden">
                                        <p class="text-ellipse">{{ file?.fileName }}</p>
                                    </div>
                                </li>

                            }
                        </ul>
                    }
                }
        </div>
    }
}

<ng-template #showFormulas>
    <div class="flexbox-column gap-8">
        <span class="fs-3">Formulas for Calculating Amortization Value</span>
        <ul class="flexbox-column gap-4 ps-4">
            <li class="text-start">
                <span> Straight Line = (Opening Balance (OB1) - Residual Value)/Useful Life</span>
            </li>
            <li class="text-start">
                <span>Decline = (Opening Balance (OB1) * (rate/100))</span>
            </li>
            <li class="text-start">
                <span>Sum of Years = (Useful Life(Useful Life + 1))/2</span>
                <span>Sum of Years Digits = (Remaining life /Sum of Years) * (Opening Balance (OB1) - Residual Value)</span>
            </li>
            <li class="text-start">
                <span>Units of Production = ((Opening Balance (OB1) - Residual Value) / Estimated Production) * Units Produced</span>
            </li>
        </ul>
    </div>
</ng-template>
